export default function () {
  /**
   * @description Форматируем данные о доставке в формат календаря
   */
  const formatCalendarDays = (data) => {
    if (data) {
      const possibleDeliveryDates = {}

      /**
       * @description Иногда из за ошибки на бэке возвращается массив
       */
      if (Array.isArray(data)) {
        let evening = data.filter(value => value.type === 'evening')
        if (!evening.length) {
          evening = data.filter(value => value.dayTime === 'evening')
        }
        const {
          dates: eveningDates = [],
          times: eveningTimes = [],
        } = evening[0] || {}

        let morning = data.filter(value => value.type === 'morning')
        if (!morning.length) {
          morning = data.filter(value => value.dayTime === 'morning')
        }
        const {
          dates: morningDates = [],
          times: morningTimes = [],
        } = morning[0] || {}

        for (const index in morningDates) {
          if (Object.prototype.hasOwnProperty.call(morningDates, index)) {
            possibleDeliveryDates[morningDates[index]] = {
              morning: morningTimes,
            }
          }
        }

        for (const index in eveningDates) {
          if (Object.prototype.hasOwnProperty.call(eveningDates, index)) {
            if (
              Object.prototype.hasOwnProperty.call(
                possibleDeliveryDates,
                eveningDates[index],
              )
            ) {
              possibleDeliveryDates[eveningDates[index]].evening = eveningTimes
            } else {
              possibleDeliveryDates[eveningDates[index]] = {
                evening: eveningTimes,
              }
            }
          }
        }
      } else {
        const {
          possibleDeliveryDays = {},
        } = data

        for (const date in possibleDeliveryDays) {
          const {
            evening = null,
            morning = null,
          } = possibleDeliveryDays[date]

          if (morning) {
            const {
              intervals = [],
            } = morning

            possibleDeliveryDates[date] = {
              morning: intervals,
            }
          }

          if (evening) {
            const {
              intervals = [],
            } = evening

            if (Object.prototype.hasOwnProperty.call(possibleDeliveryDates, date)) {
              possibleDeliveryDates[date].evening = intervals
            } else {
              possibleDeliveryDates[date] = {
                evening: intervals,
              }
            }
          }
        }
      }

      return possibleDeliveryDates
    }

    return null
  }

  return {
    formatCalendarDays,
  }
}
